import { gql } from '@apollo/client';

export const SIGN_UP_USER = gql`
  mutation Flex_SignUpUser($input: SignUpUserInput!) {
    plan: signUpUser(input: $input) {
      id
      planTemplateId
    }
  }
`;
